export default __webpack_public_path__ + "static/media/up.e9d0a356.svg";